import { DateObject } from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";

const formatChartDateDaily = (date, dataType) => {
  const dateObject = new Date(date);
  const year = dateObject.getUTCFullYear();
  const month = (dateObject.getUTCMonth() + 1).toString().padStart(2, "0");
  const day = dateObject.getUTCDate().toString().padStart(2, "0");

  if (dataType === "online") {
    // For "online" dataType, return from 00:00:00 to 23:59:59 of the same day
    const startDate = `${year}-${month}-${day} 00:00:00`;
    const endDate = `${year}-${month}-${day} 23:59:59`;

    return {
      startDate,
      endDate,
    };
  } else if (
    dataType === "hourly" ||
    dataType === "twelve" ||
    dataType === "twentyFour"
  ) {
    const theEndDate = `${year}-${month}-${day} 22:00:00`;

    // Create a new Date object with a UTC time
    const gregorianDate = new Date(`${year}-${month}-${day}T23:00:00Z`);

    // Subtract one day from the UTC date
    gregorianDate.setUTCDate(gregorianDate.getUTCDate() - 1);

    const theStartDate = `${gregorianDate.getUTCFullYear()}-${(
      gregorianDate.getUTCMonth() + 1
    )
      .toString()
      .padStart(2, "0")}-${gregorianDate
      .getUTCDate()
      .toString()
      .padStart(2, "0")} 23:00:00`;

    return {
      startDate: theStartDate,
      endDate: theEndDate,
    };
  }
};

const formatChartDateWeekly = (dateRange, dataType) => {
  if (dateRange && dateRange.length === 2) {
    if (
      dataType === "hourly" ||
      dataType === "twelve" ||
      dataType === "twentyFour"
    ) {
      // Convert start date to Gregorian and subtract 1 day
      const startDateObject = new DateObject(dateRange[0]).toDate();
      startDateObject.setUTCDate(startDateObject.getUTCDate() - 1);

      const startYear = startDateObject.getUTCFullYear();
      const startMonth = (startDateObject.getUTCMonth() + 1)
        .toString()
        .padStart(2, "0");
      const startDay = startDateObject.getUTCDate().toString().padStart(2, "0");

      const formattedStartDate = `${startYear}-${startMonth}-${startDay}%2023:00:00`;

      // Convert end date to Gregorian without modification
      const endDateObject = new DateObject(dateRange[1]).toDate();
      endDateObject.setUTCDate(endDateObject.getUTCDate() - 1);

      const endYear = endDateObject.getUTCFullYear();
      const endMonth = (endDateObject.getUTCMonth() + 1)
        .toString()
        .padStart(2, "0");
      const endDay = endDateObject.getUTCDate().toString().padStart(2, "0");

      const formattedEndDate = `${endYear}-${endMonth}-${endDay}%2023:00:00`;

      return {
        startDate: formattedStartDate,
        endDate: formattedEndDate,
      };
    } else if (dataType === "daily") {
      // Convert start date to Gregorian and subtract 1 day
      const startDateObject = new DateObject(dateRange[0]).toDate();
      startDateObject.setUTCDate(startDateObject.getUTCDate() - 1);

      const startYear = startDateObject.getUTCFullYear();
      const startMonth = (startDateObject.getUTCMonth() + 1)
        .toString()
        .padStart(2, "0");
      const startDay = startDateObject.getUTCDate().toString().padStart(2, "0");

      const formattedStartDate = `${startYear}-${startMonth}-${startDay}%2010:00:00`;

      // Convert end date to Gregorian without modification
      const endDateObject = new DateObject(dateRange[1]).toDate();

      const endYear = endDateObject.getUTCFullYear();
      const endMonth = (endDateObject.getUTCMonth() + 1)
        .toString()
        .padStart(2, "0");
      const endDay = endDateObject.getUTCDate().toString().padStart(2, "0");

      const formattedEndDate = `${endYear}-${endMonth}-${endDay}%2010:00:00`;

      return {
        startDate: formattedStartDate,
        endDate: formattedEndDate,
      };
    }
  }
  return null;
};

const formatChartDateCustom = (startDate, endDate, dateType) => {
  if (dateType === "online") {
    const theStart = new Date(startDate);
    const theStartYear = theStart.getUTCFullYear();
    const theStartMonth = (theStart.getUTCMonth() + 1)
      .toString()
      .padStart(2, "0");
    const theStartDay = theStart.getUTCDate().toString().padStart(2, "0");

    // Create a new Date object with a UTC time set to midnight
    const gregorianStartDate = new Date(
      `${theStartYear}-${theStartMonth}-${theStartDay}T00:00:00Z`
    );

    // Subtract one day from the UTC date
    gregorianStartDate.setUTCDate(gregorianStartDate.getUTCDate());

    const theFormattedStartDate = `${gregorianStartDate.getUTCFullYear()}-${(
      gregorianStartDate.getUTCMonth() + 1
    )
      .toString()
      .padStart(2, "0")}-${gregorianStartDate
      .getUTCDate()
      .toString()
      .padStart(2, "0")}%2023:00:00`;

    const theEnd = new Date(endDate);
    const theEndYear = theEnd.getUTCFullYear();
    const theEndMonth = (theEnd.getUTCMonth() + 1).toString().padStart(2, "0");
    const theEndDay = theEnd.getUTCDate().toString().padStart(2, "0");
    const theFormattedEndDate = `${theEndYear}-${theEndMonth}-${theEndDay}%2023:00:00`;

    return {
      startDate: theFormattedStartDate,
      endDate: theFormattedEndDate,
    };
  } else if (dateType === "hourly") {
    const startDateObject = new DateObject(startDate).toDate();
    startDateObject.setUTCDate(startDateObject.getUTCDate() - 1);
    const theStartYear = startDateObject.getUTCFullYear();
    const theStartMonth = (startDateObject.getUTCMonth() + 1)
      .toString()
      .padStart(2, "0");
    const theStartDay = startDateObject
      .getUTCDate()
      .toString()
      .padStart(2, "0");

    // Create a new Date object with a UTC time set to midnight
    const gregorianStartDate = new Date(
      `${theStartYear}-${theStartMonth}-${theStartDay}T00:00:00Z`
    );

    // Subtract one day from the UTC date
    gregorianStartDate.setUTCDate(gregorianStartDate.getUTCDate());

    const theFormattedStartDate = `${gregorianStartDate.getUTCFullYear()}-${(
      gregorianStartDate.getUTCMonth() + 1
    )
      .toString()
      .padStart(2, "0")}-${gregorianStartDate
      .getUTCDate()
      .toString()
      .padStart(2, "0")}%2023:00:00`;

    const endDateObject = new DateObject(endDate).toDate();
    endDateObject.setUTCDate(endDateObject.getUTCDate() - 1);
    const theEndYear = endDateObject.getUTCFullYear();
    const theEndMonth = (endDateObject.getUTCMonth() + 1)
      .toString()
      .padStart(2, "0");
    const theEndDay = endDateObject.getUTCDate().toString().padStart(2, "0");
    const theFormattedEndDate = `${theEndYear}-${theEndMonth}-${theEndDay}%2023:00:00`;

    return {
      startDate: theFormattedStartDate,
      endDate: theFormattedEndDate,
    };
  } else if (dateType === "daily") {
    const startDateObject = new DateObject(startDate).toDate();
    startDateObject.setUTCDate(startDateObject.getUTCDate() - 1);
    const theStartYear = startDateObject.getUTCFullYear();
    const theStartMonth = (startDateObject.getUTCMonth() + 1)
      .toString()
      .padStart(2, "0");
    const theStartDay = startDateObject
      .getUTCDate()
      .toString()
      .padStart(2, "0");

    // Create a new Date object with a UTC time set to midnight
    const gregorianStartDate = new Date(
      `${theStartYear}-${theStartMonth}-${theStartDay}T00:00:00Z`
    );

    // Subtract one day from the UTC date
    gregorianStartDate.setUTCDate(gregorianStartDate.getUTCDate());

    const theFormattedStartDate = `${gregorianStartDate.getUTCFullYear()}-${(
      gregorianStartDate.getUTCMonth() + 1
    )
      .toString()
      .padStart(2, "0")}-${gregorianStartDate
      .getUTCDate()
      .toString()
      .padStart(2, "0")}%2023:00:00`;

    const endDateObject = new DateObject(endDate).toDate();
    endDateObject.setUTCDate(endDateObject.getUTCDate() - 1);
    const theEndYear = endDateObject.getUTCFullYear();
    const theEndMonth = (endDateObject.getUTCMonth() + 1)
      .toString()
      .padStart(2, "0");
    const theEndDay = endDateObject.getUTCDate().toString().padStart(2, "0");
    const theFormattedEndDate = `${theEndYear}-${theEndMonth}-${theEndDay}%2023:00:00`;

    return {
      startDate: theFormattedStartDate,
      endDate: theFormattedEndDate,
    };
  }
};

const formatChartDateMonthly = (dateValue, dateType) => {
  if (dateType !== "daily") {
    const dateObject = new Date(dateValue);

    const date = new DateObject({
      date: dateValue,
      calendar: persian,
      locale: persian_fa,
    });

    // the Persian month number
    const month = date.month.number;
    // the Persian year number
    const year = date.year;

    // Get the first day of the month
    const firstDay = new DateObject({
      year: year,
      month: month,
      day: 1,
      calendar: persian,
      locale: persian_fa,
    });

    const gregorianStartDate = new Date(firstDay);
    // Subtract one day from the UTC date
    gregorianStartDate.setUTCDate(gregorianStartDate.getUTCDate() - 1);

    const theFormattedStartDate = `${gregorianStartDate.getFullYear()}-${(
      gregorianStartDate.getMonth() + 1
    )
      .toString()
      .padStart(2, "0")}-${gregorianStartDate
      .getDate()
      .toString()
      .padStart(2, "0")}%2023:00:00`;

    // Get the first day of the next month
    const nextMonth = month === 12 ? 1 : month + 1;
    const nextMonthYear = month === 12 ? year + 1 : year;

    const firstDayNextMonth = new DateObject({
      year: nextMonthYear,
      month: nextMonth,
      day: 1,
      calendar: persian,
      locale: persian_fa,
    });

    const gregorianFirstDayNextMonth = new Date(firstDayNextMonth);

    // Subtract one day from the UTC date
    gregorianFirstDayNextMonth.setUTCDate(
      gregorianFirstDayNextMonth.getUTCDate() - 1
    );

    // Now gregorianFirstDayNextMonth is equal to LastDayOfThisMonth
    const lastDayOfMonth = gregorianFirstDayNextMonth;
    const theFormattedEndDate = `${lastDayOfMonth.getFullYear()}-${(
      lastDayOfMonth.getMonth() + 1
    )
      .toString()
      .padStart(2, "0")}-${lastDayOfMonth
      .getDate()
      .toString()
      .padStart(2, "0")}%2023:00:00`;

    return {
      startDate: theFormattedStartDate,
      endDate: theFormattedEndDate,
    };
  } else if (dateType === "daily") {
    const dateObject = new DateObject({
      date: dateValue,
      calendar: persian,
      locale: persian_fa,
    });

    // the Persian month and year numbers
    const month = dateObject.month.number;
    const year = dateObject.year;

    // Get the first day of the month
    const firstDay = new DateObject({
      year: year,
      month: month,
      day: 1,
      calendar: persian,
      locale: persian_fa,
    });

    const gregorianStartDate = new Date(firstDay);
    // Subtract one day to get the last day of the previous month
    gregorianStartDate.setUTCDate(gregorianStartDate.getUTCDate() - 1);

    const formattedStartDate = `${gregorianStartDate.getFullYear()}-${(
      gregorianStartDate.getMonth() + 1
    )
      .toString()
      .padStart(2, "0")}-${gregorianStartDate
      .getDate()
      .toString()
      .padStart(2, "0")}%2023:00:00`;

    // Get the first day of the next month
    const nextMonth = month === 12 ? 1 : month + 1;
    const nextMonthYear = month === 12 ? year + 1 : year;

    const firstDayNextMonth = new DateObject({
      year: nextMonthYear,
      month: nextMonth,
      day: 1,
      calendar: persian,
      locale: persian_fa,
    });

    const gregorianLastDayOfMonth = new Date(firstDayNextMonth);
    // Subtract one day to get the last day of the current month
    gregorianLastDayOfMonth.setUTCDate(
      gregorianLastDayOfMonth.getUTCDate() - 2
    );

    const formattedEndDate = `${gregorianLastDayOfMonth.getFullYear()}-${(
      gregorianLastDayOfMonth.getMonth() + 1
    )
      .toString()
      .padStart(2, "0")}-${gregorianLastDayOfMonth
      .getDate()
      .toString()
      .padStart(2, "0")}%2023:00:00`;

    return {
      startDate: formattedStartDate,
      endDate: formattedEndDate,
    };
  }
};

const formatChartDateYearly = (dateValue) => {
  const date = new DateObject({
    date: dateValue,
    calendar: persian,
    locale: persian_fa,
  });

  // Get the Persian year number
  const year = date.year;

  // Get the first day of the current Persian year (1 Farvardin)
  const firstDayOfCurrentYear = new DateObject({
    year: year,
    month: 1, // Farvardin is the first month
    day: 1,
    calendar: persian,
    locale: persian_fa,
  });

  // Get the formatted start date (end of the previous year)
  const gregorianFirstDayOfCurrentYear = new Date(firstDayOfCurrentYear);
  gregorianFirstDayOfCurrentYear.setDate(
    gregorianFirstDayOfCurrentYear.getDate() - 1
  );

  const formattedStartDate = `${gregorianFirstDayOfCurrentYear.getFullYear()}-${(
    gregorianFirstDayOfCurrentYear.getMonth() + 1
  )
    .toString()
    .padStart(2, "0")}-${gregorianFirstDayOfCurrentYear
    .getDate()
    .toString()
    .padStart(2, "0")}%2023:00:00`;

  // Get the last day of Esfand
  const lastDayOfYear = new DateObject({
    year: year,
    month: 12, // Esfand is the last month
    day: 29, // Start with 29, and adjust if needed
    calendar: persian,
    locale: persian_fa,
  });

  if (lastDayOfYear.daysInMonth === 30) {
    lastDayOfYear.day = 30;
  }

  // Convert the last day of the year to Gregorian
  const gregorianLastDayOfYear = new Date(lastDayOfYear);

  // Get the formatted end date
  const formattedEndDate = `${gregorianLastDayOfYear.getFullYear()}-${(
    gregorianLastDayOfYear.getMonth() + 1
  )
    .toString()
    .padStart(2, "0")}-${gregorianLastDayOfYear
    .getDate()
    .toString()
    .padStart(2, "0")}%2000:00:00`;

  return {
    startDate: formattedStartDate,
    endDate: formattedEndDate,
  };
};

export {
  formatChartDateDaily,
  formatChartDateWeekly,
  formatChartDateCustom,
  formatChartDateMonthly,
  formatChartDateYearly,
};
